/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface CreateLiveAssistDemoRequest
 */
export interface CreateLiveAssistDemoRequest {
    /**
     * 
     * @type {Date}
     * @memberof CreateLiveAssistDemoRequest
     */
    dateStarted?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateLiveAssistDemoRequest
     */
    dateTransferred?: Date;
    /**
     * 
     * @type {string}
     * @memberof CreateLiveAssistDemoRequest
     */
    systemPhoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLiveAssistDemoRequest
     */
    customerPhoneNumber?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateLiveAssistDemoRequest
     */
    isInbound?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateLiveAssistDemoRequest
     */
    sampleRate?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateLiveAssistDemoRequest
     */
    isText?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateLiveAssistDemoRequest
     */
    tags?: Array<string>;
}

/**
 * Check if a given object implements the CreateLiveAssistDemoRequest interface.
 */
export function instanceOfCreateLiveAssistDemoRequest(value: object): boolean {
    return true;
}

export function CreateLiveAssistDemoRequestFromJSON(json: any): CreateLiveAssistDemoRequest {
    return CreateLiveAssistDemoRequestFromJSONTyped(json, false);
}

export function CreateLiveAssistDemoRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLiveAssistDemoRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'dateStarted': json['dateStarted'] == null ? undefined : (new Date(json['dateStarted'])),
        'dateTransferred': json['dateTransferred'] == null ? undefined : (new Date(json['dateTransferred'])),
        'systemPhoneNumber': json['systemPhoneNumber'] == null ? undefined : json['systemPhoneNumber'],
        'customerPhoneNumber': json['customerPhoneNumber'] == null ? undefined : json['customerPhoneNumber'],
        'isInbound': json['isInbound'] == null ? undefined : json['isInbound'],
        'sampleRate': json['sampleRate'] == null ? undefined : json['sampleRate'],
        'isText': json['isText'] == null ? undefined : json['isText'],
        'tags': json['tags'] == null ? undefined : json['tags'],
    };
}

export function CreateLiveAssistDemoRequestToJSON(value?: CreateLiveAssistDemoRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'dateStarted': value['dateStarted'] == null ? undefined : ((value['dateStarted']).toISOString()),
        'dateTransferred': value['dateTransferred'] == null ? undefined : ((value['dateTransferred']).toISOString()),
        'systemPhoneNumber': value['systemPhoneNumber'],
        'customerPhoneNumber': value['customerPhoneNumber'],
        'isInbound': value['isInbound'],
        'sampleRate': value['sampleRate'],
        'isText': value['isText'],
        'tags': value['tags'],
    };
}

